"use strict";function hideBar$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.hideBar$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.navigation.hideBar";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"3.5.6"},_a[ddSdk_1.ENV_ENUM.android]={vs:"3.5.6"},_a)),exports.hideBar$=hideBar$,exports.default=hideBar$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/navigation/hideBar.js
// module id = 971
// module chunks = 106